export default __webpack_public_path__ + "static/media/help.ccb10990.svg";